module.exports = __webpack_public_path__ + "files/736802230e7da56c2f871d6581827dfe.png";